import {
  Breakpoints,
  styled,
  Text,
  Image,
  ThemeDefinition,
} from '@volkswagen-onehub/components-core';
import PillModal from '../PillModal/PillModal';

interface DisabledProps {
  disabled?: boolean;
}

interface CollapsedProps {
  collapsed?: boolean;
}

interface DropdownTextWrapperProps {
  summarisedView?: boolean;
}

interface PriceViewProps {
  isOpen?: boolean;
}

const getPaddingValues = (theme: ThemeDefinition, collapsed?: boolean) => {
  const mobile = collapsed
    ? `${theme.size.static200} ${theme.size.static250}`
    : `${theme.size.static250}`;
  const desktop = collapsed
    ? `${theme.size.static200} ${theme.size.static350}`
    : `${theme.size.static350}`;

  return {
    mobile,
    desktop,
  };
};

export const VehicleCardWrapper = styled.div(
  ({ theme }) => `
  flex-grow: 1;
  position: relative;
  border: 1px solid ${theme.colors.border.default};
  border-radius: 8px;
  height: 100%;
  display: flex;
`);

export const VehicleCardContentWrapper = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  background-color: ${theme.colors.background.primary};
  border-radius: 8px;
`);

export const DropdownWrapper = styled.div<DisabledProps & CollapsedProps>(
  ({ theme, disabled, collapsed }) => {
    const paddingVals = getPaddingValues(theme, collapsed);
    return `
      display: flex;
      align-items: center;
      cursor: pointer;
      border-bottom: 1px solid ${theme.colors.border.default};
      opacity: ${disabled ? '0.4' : '1'};
      pointer-events: ${disabled || collapsed ? 'none' : 'auto'};
      padding: ${paddingVals.mobile};
      min-height: ${collapsed ? '75px' : '90px'};

      
      @media (max-width: ${Breakpoints.b560}px) {
        .dropdown-text-wrapper-car-title {
          max-width: calc(100% - 24px);
          min-height: 48px;
        }
      }

      @media (min-width: ${Breakpoints.b960}px) {
        min-height: auto;
        padding: ${paddingVals.desktop};

      }
    `;
  }
);

export const DropdownTextWrapper = styled.div<DropdownTextWrapperProps>(
  ({ summarisedView }) => `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;

  ${
    summarisedView &&
    `@media (min-width: ${Breakpoints.b560}px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
  }`
  }
`
);

export const IndividualPriceWrapper = styled.div<DropdownTextWrapperProps>(
  ({summarisedView}) => `
  display: flex;
  justify-content: ${summarisedView ? 'space-between' : 'flex-end'};
  width: 100%;
  gap: 5px;

      @media (max-width: ${Breakpoints.b560}px) {
        justify-content: ${summarisedView ? 'flex-start' : 'space-between'};
      }
  `
);

export const VehicleCardBodyWrapper = styled.div<CollapsedProps>(
  ({ theme, collapsed }) => {
    const paddingVals = getPaddingValues(theme, collapsed);

    return `
      display: flex;
      flex-direction: column;
      flex: 1;
      position: relative;
      padding: ${paddingVals.mobile};
      overflow: auto;
      scroll-padding-block: ${theme.size.dynamic0100};

      @media (min-width: ${Breakpoints.b960}px) {
        padding: ${paddingVals.desktop};
      }
    `;
  }
);

export const CTAWrapper = styled.div<DisabledProps>(
  ({ disabled }) => `
  display: flex;
  justify-content: center;
  opacity: ${disabled ? '0' : '1'};
  pointer-events: ${disabled ? 'none' : 'auto'};
`
);

export const CarViewImageWrapper = styled.div`
  position: relative;
`;

export const TextSummary = styled(Text)<DisabledProps>(
  ({ disabled }) => `
    flex-grow: 1;
    opacity: ${disabled ? '0.4' : '1'};
`
);

export const PriceViewWrapper = styled.div<PriceViewProps>(
  ({ theme, isOpen }) => `
  display: none;
  position: absolute;
  padding: ${theme.size.dynamic0100};
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: ${theme.colors.background.primary};

  > div {
    padding-bottom: ${theme.size.dynamic0100};
  }

  @media(min-width: ${Breakpoints.b560}px) {
    display: ${isOpen ? 'block' : 'none'};
  }

`
);

export const DisabledMessage = styled(Text)(
  ({theme}) => `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  text-align: center;
  color: ${theme.colors.content.tertiary};
`);

export const DisabledCTAWrapper = styled(Text)(({ theme }) => {
  return `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.size.static100};

    @media (min-width: ${Breakpoints.b560}px) {
      flex-direction: row;
      justify-content: space-between;
      gap: ${theme.size.static150};
      min-height: 44px;
      align-items: end;
    }
`;
});

export const TotalPriceWrapper = styled.div<DisabledProps>(
  ({ theme, disabled }) => `
  display: flex;
  gap: ${theme.size.dynamic0020};
  opacity: ${disabled ? '0' : '1'};
  flex-shrink: 0;
  align-items: center;

  .price-wrapper-fw {
    width:100%;
  }
`
);

export const IconWrapper = styled.div<DisabledProps>(
  ({ theme, disabled }) => `
  margin-left: ${theme.size.dynamic0020};
  display: flex;
  align-self: start;
  width: 20px;
  opacity: ${disabled ? '0' : '1'};
  position: absolute;
    top:16px;
    right:16px;
  
  @media (min-width: ${Breakpoints.b560}px) {
    display: block;
    margin-bottom: 0;
    margin-left: ${theme.size.dynamic0040};
    align-self: baseline;
    position: unset;
    
  }
`
);

export const CarViewImage = styled(Image)`
  height: auto;
`;

export const StyledStockPill = styled(PillModal)`
  transform: translate(-50%, -50%);
  position: absolute;
  top: 0%;
  left: 50%;
  z-index: 1;
  width: max-content;
`;
